import React from "react";
import { Icon, Row } from "@amzn/meridian";
import cameraTokens from "@amzn/meridian-tokens/base/icon/camera";

interface CaptureButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Reusable capture button component
 * Displays camera icon for capturing photos
 */
const CaptureButton: React.FC<CaptureButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <Row
      spacingInset="none 500 500"
      alignmentHorizontal="center"
      className="camera-actions-wrapper"
    >
      <div
        className="picture-capturing-icon-wrapper"
        onClick={disabled ? undefined : onClick}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <Icon tokens={cameraTokens} />
      </div>
    </Row>
  );
};

export default CaptureButton;
